import { render, staticRenderFns } from "./WarehouseNotification.vue?vue&type=template&id=13b754da&"
import script from "./WarehouseNotification.vue?vue&type=script&lang=js&"
export * from "./WarehouseNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports